import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import * as fromPortalTeams from './state/portal-teams.reducer';
import { PortalTeamsEffects } from './state/portal-teams.effects';

@NgModule({
    imports: [
        StoreModule.forFeature(
            fromPortalTeams.PORTALTEAMS_FEATURE_KEY,
            fromPortalTeams.reducer
        ),
        EffectsModule.forFeature([PortalTeamsEffects]),
    ],
})
export class HubAdministrationPortalTeamsStateModule {}
